import { useState, useEffect } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import ErrorBox from "@/components/Error/Box";
import { SetPresence } from "@/components/Dropdown/SetPresence";
import { UserSettings } from '@/components/Dialogs/UserSettings';
import Icon from '@/icons';
import { useVoice } from '@/VoiceSystem';
import { Link } from 'react-router-dom';
import Tippy from '@tippyjs/react';
let userPresences = new Map([
    [1, "green"],
    [2, "orange"],
    [3, "red"],
    [0, "gray"]
]);

export default function UserBottom({ user, socket }: { user: any, socket: any }) {
    const [userPresence, setUserPresence] = useState<number>(user?.user?.presence);
    useEffect(() => {
        if (!socket) return;
        const handleMessage = (event: MessageEvent) => {
            const data = JSON.parse(event.data);
            if (data.t === "PRESENCE_UPDATE" && data.d.userId === user.user.id) setUserPresence(data.d.presence);
            if (data.t == "USER_PROFILE_UPDATED" && data.d.user.id === user.user.id) {
                user.user = { ...user.user, ...data.d.user };
            }
        };

        socket.addEventListener('message', handleMessage);

        return () => {
            socket.removeEventListener('message', handleMessage);
        };
    }, [socket, user?.user?.id]);

    let a = useVoice()
    return (
        <>
            <div className='p-2 bg-brand-dark sm:rounded-lg'>
                {a?.channel?.name && (
                    <div className='rounded-t-lg w-full  border-brand-back bg-brand-back border-b'>
                        <div className='w-full p-2 items-start flex justify-between'>
                            <div className='w-full'>

                                <div className='flex flex-col w-full'>
                                    {a.channel.status == "connecting" && (
                                        <div className='text-orange-300 font-bold'>Connecting</div>
                                    )}

                                    {a.channel.status == "connected" && (
                                        <div className='text-green-300 font-bold'>Connected</div>
                                    )}

                                    {a.channel.status == "rtcConnecting" && (
                                        <div className='text-orange-300 font-bold'>Connecting to RTC</div>
                                    )}

                                    {a.channel.status == "disconnected" && (
                                        <div className='text-red-300 font-bold'>Disconnected</div>
                                    )}

                                    {a.channel.status == "reconnecting" && (
                                        <div className='text-yellow-300 font-bold'>Reconnecting</div>
                                    )}
                                    <div className='flex items-center gap-2'>
                                        <Link to={
                                            `/teams/${a.channel.teamId}/channels/${a.channel.id}`
                                        } className='text-gray-300 font-normal text-sm'>
                                            {a.channel.name}
                                        </Link>
                                    </div>

                                </div>
                            </div>

                            <div className='flex items-center gap-2 mt-4'>
                                <div className='text-gray-300 font-semibold text-lg mr-2 cursor-pointer hover:text-white transition-colors' onClick={() => a.leaveVoiceChannel()}>
                                    <Icon name='call-end' size='16' />
                                </div>
                            </div>



                        </div>

                        <div className='w-full flex items-center gap-2 justify-center p-2'>
                            <div className={`w-full items-center px-4 py-2 justify-center rounded flex transition-all duration-300 cursor-pointer ${a.isScreenSharing ? "bg-gradient-to-r from-purple-500 to-purple-500" : "bg-brand-default hover:bg-brand-green"}`} onClick={() => a.startScreenSharing()}>
                                {a.isScreenSharing && (
                                    <Icon name='icon-share-screen-off' size='16' />
                                ) || (
                                        <Icon name='icon-share-screen' size='16' />
                                    )}
                            </div>
                        </div>

                    </div>
                )}
                <div className={`flex -ml-2 py-2 mt-2 items-center relative justify-between ${a?.channel?.name ? 'rounded-b-lg' : 'rounded-lg'}`}>
                    <div className='absolute h-full bg-brand-back w-40 rounded-r-full'/>
                    <div className="flex ml-2 items-center">
                        <div className="relative">
                            {user?.user?.profilePicture && (
                                <img src={user?.user?.profilePicture} className="w-8 h-8 rounded-full" />
                            ) || (
                                    <div className="w-8 h-8 bg-gray-600 rounded-full items-center justify-center flex">
                                        {user?.user?.username[0]}
                                    </div>
                            )}
                            <SetPresence user={user?.user} socket={socket}>
                                <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full cursor-pointer" style={{ backgroundColor: userPresences.get(userPresence) }} />
                            </SetPresence>
                        </div>
                        <h1 className="text-gray-300 z-10 font-semibold text-sm w-28 ml-2 truncate">
                            {user?.isLoading ? "" :
                                user?.isError || user?.data?.message ?
                                    <ErrorBox message={(user.error || user.data?.message)?.toString()} />
                                    :
                                    user?.user?.username
                            }
                        </h1>
                    </div>
                    <div className='flex items-center gap-2 bg-brand-back px-4 p-2 rounded-lg'>
                        <>
                            <div className="flex items-center cursor-pointer" onClick={() => {
                                a!.setVoiceData({
                                    isMuted: !a!.voiceData.isMuted,
                                    isDeafened: a!.voiceData.isMuted ? false : a!.voiceData.isDeafened
                                })
                            }}>
                                <Tippy content={a!.voiceData.isMuted ? "Unmute" : "Mute"}>
                                    <div className={`text-${a!.voiceData.isMuted
                                        ? "red"
                                        : "gray"
                                        }-300 font-semibold text-lg mr-2 hover:text-white transition-colors`}>
                                        <Icon name={`${a!.voiceData.isMuted
                                            ? "voice-muted"
                                            : "voice-nonmuted"
                                            }`} size='16' />
                                    </div>
                                </Tippy>
                            </div>
                            <div className="flex items-center cursor-pointer" onClick={() => {
                                a!.setVoiceData({
                                    isDeafened: !a!.voiceData.isDeafened,
                                    isMuted: a!.voiceData.isDeafened ? false : true
                                })
                            }}>
                                <Tippy content={a!.voiceData.isDeafened ? "Undeafen" : "Deafen"}>
                                    <div className={`text-${a!.voiceData?.isDeafened
                                        ? "red"
                                        : "gray"
                                        }-300 font-semibold text-lg mr-2 hover:text-white transition-colors`}>
                                        <Icon name={
                                            a!.voiceData?.isDeafened
                                                ? "voice-deafened"
                                                : "voice-nondeafened"
                                        } size='16' />
                                    </div>
                                </Tippy>
                            </div>

                        </>

                        <Tippy content="Settings">
                            <UserSettings user={user} socket={socket}>
                                <div className="flex items-center cursor-pointer">
                                    <div className="text-gray-300 font-semibold text-lg hover:text-white transition-colors">
                                        <Icon name="settings" size='16' />
                                    </div>
                                </div>
                            </UserSettings>
                        </Tippy>
                    </div>
                </div>
            </div>
        </>
    );
}
